import { useEffect, useState } from 'react';
import * as React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Avatar,
  Box,
  Paper,
  Card,
  CardHeader,
  Container,
  MenuItem,
  Button,
  Modal,
  Table,
  TableBody,
  Divider,
  CardContent,
  Grid,
  TableCell,
  TextField,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@material-ui/core';
import './style.scss';
import getInitials from 'src/utils/getInitials';
import { makeStyles } from '@material-ui/core/styles';
import {
  SEARCH_REPORT_API,
  SEARCH_UPDATE_REPORT_API,
  ADD_REPORT_API,
  REMOVE_REPORTT_API,
  BLOCK_USER_API,
} from "../../apiContants";
import AlertNotice from "../common/alertCommon";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },

  options: {
    width: "120px!important",
  },
  mui: {
    border: "1px!important",
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
  },
  modal: {
    position: "absolute",
    width: 1200,
    height: 800,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // marginTop:'50px',
    padding: "70px",
    // textAlign: 'center',
  },
  contain: {
    padding: theme.spacing(2),
    textAlign: "center",
    // color: theme.palette.text.primary,
    // backgroundColor: '#5664d2!important',
    backgroundColor: "#5664d2!important",
    color: "white!important",
    borderRadius: "0px!important",
    // height: '25px!important',
  },
  constainvalue: {
    padding: theme.spacing(2),
    border: "1px solid blue!important",
    textAlign: "center",
    color: "black!important",
    borderRadius: "0px!important",
  },
  blockedbutton: {
    display: "flex",
    justifyContent: "end",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "20px",
  },
}));
function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const currencies = [
  {
    value: "0",
    label: "Received",
  },
  {
    value: "1",
    label: "Processing",
  },
  {
    value: "2",
    label: "Finish",
  },
  {
    value: "3",
    label: "Cancel",
  },
];

const ReportListResults = ({ customers, ...rest }) => {
  // const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const classes = useStyles();
  const [reg, regSet] = useState(Array);
  const [regs, regsSet] = useState(Array);
  const [open, setOpen] = React.useState(false);
  const [currency, setCurrency] = React.useState("Received");
  const handleChangeDomain = (event) => {
    setCurrency(event.target.value);
  };
  const [modalStyle] = React.useState(getModalStyle);
  const [page, setPage] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);
  const [alertContent, setAlertContent] = useState(null);

  const Getdatas = async () => {
    const getdatas = await axios.get(
      SEARCH_REPORT_API +
        `collectible_id=${value.content}&status=${value.status}`
    );
    const reges = getdatas.data.reports;
    regSet(reges);
  };
  const updatedatas = async (reg) => {
    const updatedatas = await axios
      .put(SEARCH_UPDATE_REPORT_API + `id=${regs.id}`)
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        setOpenAlert(true);
        setAlertContent("Update Error !");
      });
    if (updatedatas?.status === 200) {
      setOpenAlert(true);
      setOpen(false);
      setAlertContent("Update Success !");
    }
  };

  const addTag = async (reg) => {
    const updatestatus = await axios
      .post(ADD_REPORT_API + `collectible_id=${regs.collectible.id}`)
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        setOpenAlert(true);
        setAlertContent("Add TAG  Error !");
      });
    if (updatestatus?.status === 200) {
      setOpenAlert(true);
      setOpen(false);
      setAlertContent("Add TAG Success !");
    }
  };
  const removeTag = async (reg) => {
    const updatestatus = await axios
      .post(REMOVE_REPORTT_API + `collectible_id=${regs.collectible.id}`)
      .then((res) => {
        if (res.status === 200) {
          setOpenAlert(true);
          setOpen(false);
          setAlertContent("Remove TAG Success !");
        }
      })
      .catch((error) => {
        setOpenAlert(true);
        setAlertContent("Remove TAG  Error !");
      });
    console.log(updatestatus);
    
  };
  const blockid = async () => {
    const block = await axios
      .put(BLOCK_USER_API + regs.collectible.id)
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        setOpenAlert(true);
        setAlertContent("Block TAG  Error !");
      });
    handleClose();
    if (block?.status === 200) {
      setOpenAlert(true);
      setOpen(false);
      setAlertContent("Block Success !");
    }
  };
  const handleOpen = (customer, idx) => {
    regsSet(customer);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const [value, setValues] = React.useState({
    status: "",
    content: "",
  });
  const handleChangeForm = (status) => (event) => {
    setValues({ ...value, [status]: event.target.value });
    setCurrency(event.target.value);
  };
  const handleChangeFormContent = (content) => (event) => {
    setValues({ ...value, [content]: event.target.value });
  };
  const handleLimitChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };
  useEffect(() => {}, []);
  const body = (
    <Box>
      <div style={modalStyle} className={classes.modal}>
        <div className="title">
          <h2>Request ID :</h2>
          <Button onClick={() => updatedatas(reg)}>Recieve this request</Button>
        </div>
        <Grid container spacing={3}>
          <Grid item lg={5} md={6} xs={12}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>Wallet Ad</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>
                      {regs?.account?.address ? regs.account.address : "----"}
                    </Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>User Name</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>
                      {regs?.account?.username.String
                        ? regs.account.username.String
                        : "----"}
                    </Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>Email</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>----</Paper>
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
          <Grid item lg={7} md={6} xs={12}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>Request time</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>----</Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>Request status</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>
                      {regs.status === 0
                        ? "Recieved"
                        : regs.status === 1
                        ? "Processing"
                        : regs.status === 2
                        ? "Finished"
                        : regs.status === 3
                        ? "Cancel"
                        : "----"}
                    </Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>Support Info</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>----</Paper>
                  </Grid>
                </Grid>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item lg={12} md={6} xs={12}>
            <Card>
              <CardContent>
                <Grid container>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>Report Item Link</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>
                      {regs?.collectible?.id ? (
                        <a
                          href={`https://app.nftencer.com/view?id=${regs.collectible.id}`}
                        >
                          https://app.nftencer.com/view?id=
                          {regs.collectible.id}
                        </a>
                      ) : (
                        "----"
                      )}
                    </Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>
                      Send report from user
                    </Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>----</Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper className={classes.contain}>Report Reason</Paper>
                  </Grid>
                  <Grid item xs={9}>
                    <Paper className={classes.constainvalue}>
                      {regs.type === 1
                        ? "Copyright"
                        : regs.type === 2
                        ? "Sexual Content"
                        : regs.type === 3
                        ? "Violent or repulsive content"
                        : regs.type === 4
                        ? "Hateful or abusive content"
                        : regs.type === 5
                        ? "Harmful or dangerous acts"
                        : regs.type === 6
                        ? "Spam or misleading"
                        : "----"}
                    </Paper>
                  </Grid>
                </Grid>
                <div className="Blocked_button">
                  <Button onClick={() => blockid()}>Block this item</Button>
                  <Button onClick={() => addTag(reg)}>Add tag report</Button>
                  <Button onClick={() => removeTag(reg)}>
                    Remove tag report
                  </Button>
                </div>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
  return (
    <Card>
      <CardHeader title="Report Manager" />
      <Divider />
      <CardContent>
        <Grid container spacing={3}>
          <Grid className={classes.mui} item xs={2}>
            <span className={classes.paper}>Item ID</span>
          </Grid>
          <Grid className={classes.mui} item xs={2}>
            <TextField
              onChange={handleChangeFormContent("content")}
              className="containt"
              placeholder="enter item ID"
              inputProps={{
                min: 0,
                style: { textAlign: "center", width: "250px" },
              }}
              id="standard-basic"
            />
          </Grid>
          <Grid className={classes.mui} item xs={2}>
            <span className={classes.paper}>Request status</span>
          </Grid>
          <Grid className={classes.mui} item xs={2}>
            <TextField
              className={classes.options}
              id="standard-select-currency"
              className="option_domain"
              select
              defaultValue="select"
              label="select"
              name="select"
              type="select"
              value={currency}
              onChange={handleChangeForm("status")}
            >
              {currencies.map((option) => (
                <MenuItem
                  className={classes.options}
                  key={option.value}
                  value={option.value}
                >
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          {/* <Grid className={classes.mui} item xs={2}>
            <button className={classes.options} type="button">
              Initialization
            </button>
          </Grid> */}
          <Grid className={classes.mui} item xs={2}>
            <button
              className={classes.options}
              type="button"
              onClick={() => Getdatas()}
            >
              Search
            </button>
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <PerfectScrollbar>
        <Box sx={{ minWidth: 1050 }}>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Request ID</TableCell>
                  <TableCell>Wallet ADD</TableCell>
                  <TableCell>User Name</TableCell>
                  <TableCell>Time</TableCell>
                  <TableCell>Request status</TableCell>
                  <TableCell>More</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reg
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((customer, idx) => (
                    <TableRow hover key={customer.id}>
                      <TableCell>{customer.id}</TableCell>
                      <TableCell>{customer.account.address}</TableCell>
                      <TableCell>
                        <Typography color="textPrimary" variant="body1">
                          {customer.account.username.String}
                        </Typography>
                      </TableCell>
                      <TableCell></TableCell>
                      <TableCell>
                        {customer.status === 0
                          ? "Recieved"
                          : customer.status === 1
                          ? "Processing"
                          : customer.status === 2
                          ? "Finished"
                          : customer.status === 3
                          ? "Cancel"
                          : "----"}
                      </TableCell>
                      <TableCell>
                        <Button onClick={() => handleOpen(customer, idx)}>
                          More
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </Box>
      </PerfectScrollbar>
      <TablePagination
        component="div"
        count={customers.length}
        onChangePage={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[5]}
      />
      <Box textAlign="center">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          {body}
        </Modal>
      </Box>
      <AlertNotice
        openAlert={openAlert}
        setOpenAlert={setOpenAlert}
        alertContent={alertContent}
      ></AlertNotice>
    </Card>
  );
};

ReportListResults.propTypes = {
  customers: PropTypes.array.isRequired
};

export default ReportListResults;
